import { getMallContentDetail } from "../../../api/recommend"
import { mapActions, mapGetters } from "vuex"
import PageLoading from "../../../components/common/PageLoading.vue"
import { getLoginState } from "../../../utils/helper"
import * as reportDic from "../../../constants/report-dictonary"
import { getParam } from "@tencent/midas-util"
import { TASK_TYPES } from "../../../store/enums"
import gameServiceZoneMixin from "../../mixins/gameServiceZone"
import Raven from "raven-js"

export default {
  data() {
    return {
      cgiInfo: null,
      currentPageLoading: true,
      intoTime: 0,
      noFoundImg: require("../../../../ui/assets/mobile/images/coupon-empty.png")
    }
  },

  mixins: [gameServiceZoneMixin],

  components: {
    PageLoading
  },

  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.initContent(vm, from)
      vm.intoTime = new Date().getTime()
      try {
        const [groupId, busId] = vm?.cgiInfo?.data?.recomInfo?.group_busId?.split("_")
        if (groupId && busId) {
          await vm.getCurrentBizDetail({
            bizgroupid: groupId,
            bizid: busId
          })
          await vm.renderTasks()
          await Promise.all([
            vm.joinTask({
              type: TASK_TYPES.SIGN
            }),
            vm.joinTask({
              type: TASK_TYPES.READ,
              join_id: vm?.cgiInfo?.data?.contentId
            })
          ])
        }
      } catch (e) {
        Raven.captureException(new Error("news init error"), {
          tags: { type: "news-init-error" },
          extra: {
            e,
            getters: vm.$store.getters,
            rootState: vm.$store.state
          }
        })
      }
    })
  },

  async beforeRouteUpdate(to, from, next) {
    this.initContent()
    next()
  },

  computed: {
    ...mapGetters(["sandbox", "pf", "loginState"]),
    content() {
      if (!this.cgiInfo || this.cgiInfo.ret) {
        return
      }

      return this.cgiInfo.data
    },

    /**
     * hack 发布时间
     * 中台返回的 publish time 有的时候是时间戳有的时候是日期，这里要 hack 处理下
     * @returns {(function(): (*|undefined))|number}
     */
    publishTime() {
      if (this.content) {
        let time = this.content.analyzeInfo.publishTime + ""

        return new Date(time.replace(/-/g, "/"))
      }
    }
  },

  methods: {
    ...mapActions(["reportUserAction", "renderTasks", "joinTask"]),

    async initContent(vm = this, from) {
      vm.currentPageLoading = true
      vm.cgiInfo = null

      // 如果分享上带了分享的id, 则优先使用分享的id
      let contentId = vm.$route.params.contentId

      if (from && from.matched && !from.matched.length) {
        let shareVideoId = getParam("shareVideoId")

        if (shareVideoId) {
          contentId = shareVideoId
        }
      }

      vm.cgiInfo = await getMallContentDetail({
        contentId,
        sandbox: vm.sandbox,
        ...getLoginState(vm.loginState),
        pf: vm.pf,
        offerId: vm.$route.query.offerId || "",
        sceneId: vm.$route.query.sceneId || ""
      })

      vm.currentPageLoading = false

      let pfStructure = vm.$route.query.pfStructure

      vm.reportUserAction({
        iformat: reportDic.PAGE_VIEW.CONTENT_DETAIL,
        pfStructure,
        resultInfo: {
          contentId: vm.$route.params.contentId,
          pfStructure
        }
      })

      // 调用组件内的 callback 函数
      if (typeof vm.beforeRouteEnterCallBack === "function") {
        vm.beforeRouteEnterCallBack(vm)
      }
    }
  }
}
